import { Alert, Box, Button, Snackbar, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";

import { AppPageNoMaxWidth } from "@/layouts";
import { ActivitiesTableWithData } from "@/pages/UserDetails/components/CallPlans/CreateCallPlanModal/ActivitiesTable";

import {
  activitiesLibraryPageCreateButtonSx,
  activitiesLibraryPageFiltersSx,
  activitiesLibraryPageHeaderSx,
  activitiesLibraryPageHeadingSx,
  activitiesLibraryPageLayoutSx,
  activitiesLibraryPageTableWrapSx,
} from "./ActivitiesLibraryPage.styles";

export const ActivitiesLibraryPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [publishToast, setPublishToast] = useState<string | null>(null);

  useEffect(() => {
    const msg = (location.state as { activityPublishedMessage?: string } | null)
      ?.activityPublishedMessage;
    if (!msg) {
      return;
    }
    setPublishToast(msg);
    navigate(location.pathname, { replace: true, state: null });
  }, [location.pathname, location.state, navigate]);

  return (
    <>
      <AppPageNoMaxWidth>
        <Box sx={activitiesLibraryPageLayoutSx}>
          <Box sx={activitiesLibraryPageHeaderSx}>
            <Typography component="h1" sx={activitiesLibraryPageHeadingSx}>
              Activities
            </Typography>
            <Button
              component={RouterLink}
              to="/activities/new"
              variant="contained"
              disableElevation
              sx={activitiesLibraryPageCreateButtonSx}
            >
              Create activity
            </Button>
          </Box>
          <ActivitiesTableWithData
            skip={false}
            libraryMode
            showQueryErrorAlert
            filterWrapSx={activitiesLibraryPageFiltersSx}
            mainColumnWrapSx={activitiesLibraryPageTableWrapSx}
          />
        </Box>
      </AppPageNoMaxWidth>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={Boolean(publishToast)}
        autoHideDuration={4000}
        onClose={() => setPublishToast(null)}
      >
        <Alert severity="success" onClose={() => setPublishToast(null)}>
          {publishToast}
        </Alert>
      </Snackbar>
    </>
  );
};
